import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import authentication from './modules/authentication';
import accountCreation from './modules/accountCreation';
import userCreationByAdmin from './modules/userCreationByAdmin';
import home from './modules/home';
import errors from './modules/errors';
import fundingSource from './modules/fundingSource';
import documentUpload from './modules/documentUpload';
import microDepositsVerification from './modules/microDepositsVerification';
import note from './modules/note';
import question from './modules/question';
import account from './modules/account';
import transaction from './modules/transaction';
import transactionModal from './modules/transactionModal';
import checkWireModal from './modules/checkWireModal';
import information from './modules/information';
import success from './modules/success';
import user from './modules/user';
import successAlert from './modules/successAlert';
import impactPreferences from './modules/impactPreferences';
import documentViews from './modules/documentViews';
import monthlyMaturities from './modules/monthlyMaturities';
import idle from './modules/idle';
import kba from './modules/kba';
import feedback from './modules/feedback';

Vue.use(Vuex);

const store =
  new Vuex.Store({
    modules: {
      app,
      authentication,
      accountCreation,
      userCreationByAdmin,
      home,
      errors,
      fundingSource,
      documentUpload,
      microDepositsVerification,
      note,
      transaction,
      transactionModal,
      checkWireModal,
      question,
      account,
      information,
      success,
      successAlert,
      user,
      impactPreferences,
      documentViews,
      monthlyMaturities,
      idle,
      kba,
      feedback,
    },
  });

const initialStateCopy = JSON.parse(JSON.stringify(store.state));

export function resetState() {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)));
}

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js